export default __webpack_public_path__ + "static/media/background.e47d96a4.jpg";